import React from 'react';

/**
 * ICP Current Value Card for Managerial Cross General report
 * Displays the current ICP value with traffic light color and status label
 *
 * Props:
 *   value {number} – current ICP score (0-100)
 */
const ManCrossIcpCurrentCard = ({ value = 0 }) => {
    const getStatus = (val) => {
        if (val >= 80) return { color: '#1E8449', label: 'ÓPTIMO' };
        if (val >= 65) return { color: '#F9A825', label: 'ACEPTABLE' };
        if (val >= 50) return { color: '#E67E22', label: 'RIESGO MODERADO' };
        return { color: '#C0392B', label: 'RIESGO CRÍTICO' };
    };

    const status = getStatus(value);
    const displayValue = Math.round(value);

    return (
        <div className="mgcr-icp-current-wrap">
            <div className="mgcr-icp-current-box" style={{ backgroundColor: status.color }}>
                <div className="mgcr-icp-current-number">{displayValue}</div>
                <div className="mgcr-icp-current-label">ICP</div>
            </div>
            <div className="mgcr-icp-current-status">{status.label}</div>
        </div>
    );
};

export default ManCrossIcpCurrentCard;
